export function replaceSlash(url: string) {
  return url.replace(/^\/|\/$/g, '');
}

export default function isUrlInIgnoreList(url: string, ignoreRules: (string | RegExp)[] | undefined): boolean {
  if (!url || !Array.isArray(ignoreRules)) return true;

  return ignoreRules.some((urlItem: string | RegExp) => {
    if (typeof urlItem === 'string') {
      return replaceSlash(urlItem) === replaceSlash(url);
    }
    return urlItem.test(url);
  });
}
